import {
  TERMINATE_REVIEWER_FETCHING,
  TERMINATE_REVIEWER_SUCCESS,
  TERMINATE_REVIEWER_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TERMINATE_REVIEWER_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case TERMINATE_REVIEWER_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case TERMINATE_REVIEWER_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
